<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
		<path
			:style="`fill:${active ? globalColors.titulo : globalColors.border}`"
			fill-rule="nonzero"
			d="M0 6.906c0 .99.679 1.813 1.594 2.05v6.982H.53a.532.532 0 0 0 0 1.062H16.47a.53.53 0 1 0 0-1.063h-1.063v-6.98A2.121 2.121 0 0 0 17 6.907v-.532H0v.531zm10.625 2.125a2.124 2.124 0 0 0 2.125-2.125c0 .99.679 1.813 1.594 2.05v6.982H6.375V9.03A2.124 2.124 0 0 0 8.5 6.906c0 1.174.953 2.125 2.125 2.125zm-4.781-.074v6.98H2.656v-6.98a2.121 2.121 0 0 0 1.594-2.05c0 .988.679 1.812 1.594 2.05zm9.031-7.363H2.125L0 5.844h17l-2.125-4.25zM4.489 2.774L3.426 4.9a.268.268 0 0 1-.357.119.265.265 0 0 1-.118-.356l1.062-2.125a.266.266 0 0 1 .475.237zm2.125 0L5.55 4.9a.268.268 0 0 1-.357.119.265.265 0 0 1-.118-.356l1.062-2.125a.267.267 0 0 1 .356-.12.266.266 0 0 1 .12.357zm2.152 2.007a.265.265 0 1 1-.531 0V2.656a.265.265 0 1 1 .53 0v2.125zm3.05.233a.264.264 0 0 1-.36-.105l-1.163-2.125a.266.266 0 1 1 .467-.255l1.162 2.125a.267.267 0 0 1-.106.36zm2.115.005a.263.263 0 0 1-.355-.12l-1.063-2.124a.265.265 0 0 1 .119-.356.267.267 0 0 1 .357.119l1.062 2.125c.064.13.013.29-.12.356zM4.516 12.83v-1.224a.525.525 0 0 1-.266-.45.532.532 0 0 1 1.063 0 .523.523 0 0 1-.266.45v1.224a.523.523 0 0 1 .266.45.53.53 0 1 1-1.063 0c0-.195.11-.357.266-.45zM2.125.53c0-.293.239-.531.531-.531h11.688a.53.53 0 1 1 0 1.063H2.656A.532.532 0 0 1 2.125.53zm7.186 11.344l-.375-.375 1.502-1.503.376.376-1.503 1.502zm0 1.503l-.375-.376 3.005-3.005.375.376-3.005 3.005zm2.63-1.878l.375.375-1.502 1.503-.376-.376 1.503-1.502z"
		/>
	</svg>
</template>
<script>
export default {
	name: 'store-svg',
	props: {
		active: {
			default: false,
			type: [Boolean, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// storeSvg.vue?065f0df0